import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle, PageWrapper } from '../../../components';
import { GENERATOR_ROUTES, GeneratorTabs, SavedCreativesTab } from '../components';

/** Biblioteka gotowych kreacji pod własnym adresem, do podlinkowania i zakładek. */
export const MyCreatives: FC = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <PageTitle title="Generator reklam" />
      <div className="flex flex-col gap-8">
        <GeneratorTabs />
        <SavedCreativesTab onOpen={() => navigate(GENERATOR_ROUTES.editor)} />
      </div>
    </PageWrapper>
  );
};
